module.exports = __webpack_public_path__ + "img/e-academy.993a3f3e.png";